(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kin-product-enquiry"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kin-product-enquiry')) {
    customElements.define('kin-product-enquiry', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const listener = {signal: this.controller.signal};
        this.optionNames = JSON.parse(this.dataset.optionNames || '[]');
        this.optionValues = JSON.parse(this.dataset.optionValues || '[]');
        this.variantTitle = this.dataset.variantTitle;
        const purchaseForm = document.getElementById(this.dataset.productForm);
        purchaseForm?.addEventListener('variant:change', event => {
          this.optionValues = event.detail.variant?.options || [];
          this.variantTitle = event.detail.variant?.title || this.dataset.unavailable;
          this.syncContext();
        }, listener);
        if (purchaseForm) {
          this.optionsObserver = new MutationObserver(() => this.syncContext());
          this.optionsObserver.observe(purchaseForm, {subtree: true, childList: true, attributes: true, attributeFilter: ['value', 'disabled']});
        }
        this.querySelector('details').addEventListener('toggle', () => this.syncContext(), listener);
        this.closest('.product-info')?.addEventListener('change', () => this.syncContext(), listener);
        this.querySelector('form').addEventListener('focusin', () => this.syncContext(), listener);
        this.querySelector('form').addEventListener('submit', () => this.syncContext(), {...listener, capture: true});
        this.syncContext();
      }
      disconnectedCallback() { this.controller.abort(); this.optionsObserver?.disconnect(); }
      syncContext() {
        const form = this.querySelector('form');
        const configuration = form.querySelector('[data-enquiry-configuration]');
        if (!configuration) return;
        const purchaseForm = document.getElementById(this.dataset.productForm);
        const variantId = purchaseForm?.elements.namedItem('id')?.value;
        const options = this.dataset.defaultVariant === 'true' ? [] : this.optionNames.map((name, i) => this.optionValues[i] ? `${name}: ${this.optionValues[i]}` : '').filter(Boolean);
        if (purchaseForm) {
          for (const [name, value] of new FormData(purchaseForm)) {
            const match = name.match(/^properties\[([^\]]+)\]$/);
            if (match && !match[1].startsWith('_') && typeof value === 'string' && value.trim()) {
              options.push(`${match[1]}: ${value.trim()}`);
            }
          }
        }
        const text = [...new Set(options)].join('; ');
        configuration.value = text;
        form.querySelector('[data-enquiry-options]').textContent = text;
        form.querySelector('[data-enquiry-variant]').value = this.variantTitle;
        const url = new URL(this.dataset.productUrl, location.origin);
        if (variantId && /^\d+$/.test(variantId)) url.searchParams.set('variant', variantId);
        form.querySelector('[data-enquiry-url]').value = url.href;
        url.searchParams.set('contact_posted', 'true');
        url.hash = form.id;
        form.elements.namedItem('return_to').value = url.pathname + url.search + url.hash;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kin-product-fabric-link"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
    const link=event.target.closest('.kin-fabric-guide-link');
    if(!link?.dataset.productForm)return;
    const variant=document.getElementById(link.dataset.productForm)?.elements.namedItem('id')?.value;
    if(variant){const url=new URL(link.href);url.searchParams.set('variant',variant);link.href=url.href;}
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kin-product-gallery-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kin-product-gallery-controls')) {
    customElements.define('kin-product-gallery-controls', class extends HTMLElement {
      async connectedCallback() {
        const controller = this.controller = new AbortController();
        await Promise.all(['media-carousel', 'prev-button', 'next-button'].map(name => customElements.whenDefined(name)));
        if (controller.signal.aborted || !this.isConnected) return;
        this.carousel = document.getElementById(this.dataset.carousel);
        this.gallery = this.closest('product-gallery');
        if (!this.carousel || !this.gallery) return;
        const listener = {signal: controller.signal};
        this.carousel.addEventListener('carousel:change', () => this.sync(false), listener);
        this.carousel.addEventListener('carousel:settle', () => this.sync(true), listener);
        this.carousel.addEventListener('carousel:filter', () => queueMicrotask(() => {
          if (!controller.signal.aborted) this.sync(true);
        }), listener);
        this.breakpoint = matchMedia('(max-width: 999px)');
        this.breakpoint.addEventListener('change', () => this.sync(false), listener);
        this.sync(false);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.gallery?.classList.remove('kin-gallery-controls-ready');
      }
      sync(announce) {
        const visible = this.carousel.visibleItems;
        const position = visible.indexOf(this.carousel.selectedSlide);
        if (visible.length && position < 0) {
          this.hidden = true;
          this.gallery.classList.remove('kin-gallery-controls-ready');
          return;
        }
        this.hidden = visible.length <= 1;
        this.querySelector('[data-gallery-position]').textContent = `${position + 1} / ${visible.length}`;
        this.querySelector('[is="prev-button"]').disabled = position <= 0;
        this.querySelector('[is="next-button"]').disabled = position >= visible.length - 1;
        if (announce && !this.hidden && this.breakpoint.matches) {
          this.querySelector('[data-gallery-announcement]').textContent = this.dataset.announcement.replace('__index__', position + 1).replace('__count__', visible.length);
        }
        this.classList.add('is-ready');
        this.gallery.classList.add('kin-gallery-controls-ready');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
